"use client";

import { UsedProductIndustry } from "@/@types"
import { sortArrayAlphabetically } from "@/utils/sorts";
import Link from "next/link";
import { usePathname } from "next/navigation";

type Props = {
  usedProductIndustry: UsedProductIndustry[];
}

export default function UsedProductsIndustry({ usedProductIndustry }: Props) {
  const pathName = usePathname();
  usedProductIndustry = sortArrayAlphabetically(usedProductIndustry, 'title');

  if (!Array.isArray(usedProductIndustry) || usedProductIndustry.length === 0) {
    return <p>No Industry available.</p>
  }

  return (
    <div className="relative block bg-white px-2 py-4">
      <p className="py-2 lg:pl-3 text-lg font-bold">Industrias</p>
      <div className="flex flex-col">
        {usedProductIndustry.map((industry, index) => (
          <Link
            href={`${`/equipos-usados/${industry.slug}`}`}
            key={index}
            className={`flex items-center justify-between lg:pl-4 py-1 text-base transition-colors ${pathName.includes(`/${industry.slug}`)
              ? "text-black bg-[#FFD201]"
              : "text-gray hover:text-black"
              } hover:bg-light01 hover:cursor-pointer `}
          >
            <span className="flex-1 truncate md:whitespace-normal">
              {industry.title}
            </span>
            <svg
              className="w-4 h-4 ml-2 md:hidden"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
            </svg>
          </Link>
        ))}
      </div>
    </div>
  )
}